import type { ReactElement } from 'react';
import { memo } from 'react';

import { createDecorationText, createPadding } from '../ui-utils';

import type { ILinkProps } from './link.interface';

export const Link = memo(
  ({
    underline = 'hover',
    size = 'body1',
    color = 'primary',
    weight = 'normal',
    children,
    disabled = false,
    fullWidth = false,
    pt = 0,
    pr = 0,
    pl = 0,
    pb = 0,
    className,
    display = 'flex',
    ...props
  }: ILinkProps): ReactElement => {
    function createColorLink(): string {
      if (
        color === 'my_credits_basic' ||
        color === 'my_credits_intermediate' ||
        color === 'my_credits_advanced' ||
        color === 'my_credits_expert' ||
        color === 'my_credits_preferential' ||
        color === 'my_credits_elite'
      ) {
        return color;
      }
      if (color === 'cyan_blue') return 'cyan_blue';
      if (color === 'white' || color === 'black') return `common-${color}`;
      if (color === 'pds-information-600') {
        return 'pds-information-600';
      }
      return `${color}-main`;
    }
    return (
      <a
        {...props}
        className={`
                ${createDecorationText(underline)}
                co-text-${createColorLink()}
                ${
                  disabled ? 'co-pointer-events-none' : 'co-pointer-events-auto'
                }
                ${fullWidth ? 'co-w-full' : 'co-w-auto'}
                ${createPadding({ pt, pl, pr, pb })}
                co-${display}
                co-gap-4px
                co-text-${size}
                co-cursor-pointer
                co-font-${weight}
                co-font-montserrat
                ${className}
            `}
      >
        {children}
      </a>
    );
  }
);
